
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFileDownloadGoogle as ObiFileDownloadGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-file-download-google.js';
 
 
 

 
 export const ObiFileDownloadGoogle = createComponent({
   react: React,
   tagName: 'obi-file-download-google',
   elementClass: ObiFileDownloadGoogleElement,
   events: {
     
   }
  });
 
 